import { TLenderId, TLoanId, Transaction } from '/src/lib/models';
import { ISODateTimeString } from '/src/lib/types';

/**
 * List Transactions
 */
export type TListTransactionsRequest = {
  loanId?: TLoanId;
  lenderId?: TLenderId;
  start?: ISODateTimeString;
  end?: ISODateTimeString;
};

export type TListTransactionsResponse = { transactions: Transaction[]; totals: Record<string, any> };

/**
 * List Loan Statement Transactions
 */
export type TListStatementTransactionsRequest = {
  loanId?: TLoanId;
  start?: ISODateTimeString;
  end?: ISODateTimeString;
  [key: string]: any;
};

export type TListStatementTransactionsResponse = {
  transactions: Transaction[];
  totals: Record<string, any>;
  allAdjustments: boolean;
};

/**
 * List Lender Statement Transactions
 */
export type TListLenderStatementTransactionsRequest = {
  lenderId?: TLenderId;
  start?: ISODateTimeString;
  end?: ISODateTimeString;
  [key: string]: any;
};

export type TListLenderStatementTransactionsResponse = {
  transactions: Transaction[];
  totals: Record<string, any>;
  allAdjustments: boolean;
};
